import React, { useContext } from 'react';
import { UserContext } from '../../../../context/UserContext';
import { Navigate } from 'react-router-dom';
import { Routing } from '../../../../util/routes.util';
import ProfileSettingsDetailsView from './Views/ProfileSettingsDetailsView';
import ProfileSettingsPasswordView from './Views/ProfileSettingsPasswordView';
import { t } from '../../../../types/translation/Translator';
import { TranslationKey } from '../../../../types/translation/TranslationKey';

export default function PersonalInformationSettingsScreen() {
  const { currentUser } = useContext(UserContext);
  if (!currentUser) return <Navigate to={Routing.authentication.login()} />;

  return (
    <div className='content-x content-y-screen flex flex-grow flex-col gap-8 overflow-auto'>
      <div className='grid gap-2'>
        <p className='page-title'>{t(TranslationKey.personalInformationSettingsScreenTitle).singular.upper}</p>
        <p className='subtitle'>{t(TranslationKey.personalInformationSettingsScreenSubtitle).singular.upper}</p>
      </div>
      <ProfileSettingsDetailsView user={currentUser} />
      <ProfileSettingsPasswordView />
    </div>
  );
}
